import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/280'

const ItemPopularityInDigitalOrdersTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="digital_ordering.tabs.item_popularity_in_digital_orders"
  />
)

export default ItemPopularityInDigitalOrdersTab
